<template>
  <div class="laudo-tab-container">
    <section data-testid="laudo-saida-section">
      <header class="laudo-header">
        <h3 class="laudo-title">{{ t('Laudo de Saída') }}</h3>
        <div class="laudo-header-actions">
          <Button
            v-if="canConfirm"
            :label="t('Confirmar Laudo de Saída')"
            icon="pi pi-check"
            size="small"
            severity="success"
            raised
            :loading="isSaving"
            data-testid="confirm-exit-laudo-btn"
            @click="handleConfirm"
          />
          <Button
            v-if="canSave"
            :label="t('Salvar')"
            icon="pi pi-save"
            size="small"
            severity="primary"
            raised
            :loading="isSaving"
            data-testid="save-exit-laudo-btn"
            @click="handleSave"
          />
          <Button
            v-if="itemId > 0"
            :label="t('Enviar laudo ao cliente')"
            icon="pi pi-whatsapp"
            severity="success"
            size="small"
            data-testid="laudo-saida-enviar-link-btn"
            @click="handleEnviarLaudo"
          />
        </div>
      </header>
      <PDVExitReportPage
        ref="reportRef"
        :order-item-id="itemId"
        embedded
        require-production-complete
      />
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../../eventBus';
import { useLaudoPublicLink } from '../../../composables/useLaudoPublicLink';

const { t } = useI18n();
const { offerLaudoLink } = useLaudoPublicLink();

const props = defineProps<{
  itemId: number;
}>();

const reportRef = ref<{
  handleConfirm?: () => Promise<void>;
  canConfirm?: boolean;
  isSaving?: boolean;
  handleSave?: () => Promise<void>;
  canSave?: boolean;
} | null>(null);

const canConfirm = computed(() => reportRef.value?.canConfirm ?? false);
const isSaving = computed(() => reportRef.value?.isSaving ?? false);
const canSave = computed(() => reportRef.value?.canSave ?? false);

function loadData() {
  // Embedded page self-loads on mount
}

async function handleConfirm() {
  if (reportRef.value?.handleConfirm) {
    await reportRef.value.handleConfirm();
  }
}

async function handleSave() {
  if (reportRef.value?.handleSave) {
    await reportRef.value.handleSave();
  }
}

async function handleEnviarLaudo() {
  const ok = await offerLaudoLink(props.itemId, 'saida');
  if (!ok) eventBus.emit('globalMessage.error', t('Não foi possível gerar o link do laudo'));
}

defineExpose({ loadData });
</script>

<style scoped>
.laudo-tab-container {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.laudo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.laudo-header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.laudo-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: var(--p-text-color);
}
</style>
